import { useMemo, createElement } from 'react';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Button } from '../../Button/Button.es.js';
import { SelectList } from '../../SelectList/SelectList.es.js';

const MultiSelectComboboxOptions = ({ loading, items, inputValue, locale, highlightedIndex, onClearInput, getItemProps, getMenuProps, truncate = true, disabled = false, innerRef, maxMenuItems = 6, ...props })=>{
    const noItems = items.length === 0;
    const noResults = noItems && inputValue != null;
    const content = useMemo(()=>{
        if (loading) {
            return jsx(SelectList.Loading, {});
        }
        if (noItems && !inputValue && locale?.noItemsMessage) {
            return jsx(SelectList.NoItems, {
                "data-testid": "no-items-message",
                children: locale.noItemsMessage
            });
        }
        if (noResults && Boolean(inputValue) && locale?.noResultsMessage != null && locale?.clearButtonLabel != null) {
            return jsxs(SelectList.NoResults, {
                "data-testid": "no-results-message",
                children: [
                    jsx("span", {
                        children: typeof locale.noResultsMessage === 'string' ? locale.noResultsMessage : locale.noResultsMessage(inputValue)
                    }),
                    jsx(Button, {
                        onClick: onClearInput,
                        variant: "text",
                        children: locale.clearButtonLabel
                    })
                ]
            });
        }
        return jsx(Fragment, {
            children: items.map((item, index)=>item.header ? jsx(SelectList.Item.Header, {
                    "data-testid": "list-item-header",
                    disabled: disabled,
                    children: item.label
                }, index) : /*#__PURE__*/ createElement(SelectList.Item, {
                    ...getItemProps?.({
                        index,
                        item,
                        refKey: 'innerRef'
                    }),
                    key: index,
                    className: classNames({
                        highlighted: highlightedIndex === index
                    }),
                    "data-testid": "list-item",
                    disabled: disabled,
                    item: item,
                    truncate: truncate
                }, jsx(SelectList.Item.Description, {
                    children: item.description
                }), jsx(SelectList.Item.Icon, {
                    align: "left",
                    name: item.icon
                }), jsx(SelectList.Item.Icon, {
                    align: "right",
                    name: item.tagIcon
                }), jsx(SelectList.Item.Tag, {
                    align: "right",
                    children: item.tag
                })))
        });
    }, [
        highlightedIndex,
        items,
        truncate,
        inputValue,
        loading,
        locale,
        noItems,
        disabled,
        noResults,
        onClearInput,
        getItemProps
    ]);
    return jsx(SelectList, {
        ...props,
        ...getMenuProps?.({
            refKey: 'innerRef'
        }),
        fixedHeight: false,
        maxMenuItems: maxMenuItems,
        children: content
    });
};
MultiSelectComboboxOptions.displayName = 'MultiSelectCombobox.Options';

export { MultiSelectComboboxOptions };
//# sourceMappingURL=MultiSelectCombobox.Options.es.js.map
